import { Button, Flex, Text } from '@chakra-ui/react';
import { BagTickOutline, GiftOutline } from '@aslanpay/portal-common-lib';

import { RecognitionDestination } from '../../destinations';

interface QuickActionsProps {
  onNavigate: (destination: RecognitionDestination) => void;
}

function QuickActions({ onNavigate }: QuickActionsProps) {
  return (
    <Flex
      bgColor="brand.white"
      borderRadius="10px"
      border="1px solid"
      borderColor="brand.lightGray1"
      w="full"
      p="20px"
      flexDir="column"
      gap="16px"
    >
      <Text as="h5" textStyle="h5SemiBold" color="brand.darkPurple">
        Quick actions
      </Text>
      <Flex gap="20px" flexWrap="wrap">
        <Button variant="outline" size="lg" w="200px" onClick={() => onNavigate('walletsAndPots')}>
          <BagTickOutline boxSize="20px" mr="8px" />
          Manage pots
        </Button>
        <Button variant="outline" size="lg" w="200px" onClick={() => onNavigate('gifting')}>
          <GiftOutline boxSize="20px" mr="8px" />
          Instant rewards
        </Button>
      </Flex>
    </Flex>
  );
}

export default QuickActions;
